import React, { useState, useEffect } from "react";
import {
  View,
  StyleSheet,
  TouchableOpacity,
  Text,
  ActivityIndicator,
  Pressable,
} from "react-native";
import Field2D from "./Field2D";
import ZoomedField from "./ZoomedField";
import { blockType } from "../../utils/blockType.util";

const TwoDFieldMap = (props) => {
  const [layout, setLayout] = useState(null);

  // console.log("first", props.newCordSystem);

  return (
    <View
      style={styles.container}
      onLayout={(e) => setLayout(e.nativeEvent.layout)}
    >
      <UnitComponentMap
        newCordSystem={props.newCordSystem}
        onPress={props.onPress}
        width={layout && layout.width}
        lineThickness={2}
      />

      {props.children && (
        <View
          style={{
            zIndex: 2,
            position: "absolute",
            width: layout && layout.width,
            height: layout && layout.width / 1.8,
          }}
        >
          {props.children}
        </View>
      )}
    </View>
  );
};

const UnitComponentMap = (props) => {
  const newCordSystem = props.newCordSystem;
  const width = props.width;
  const height = width && width / 1.8;
  const unitX = width && width / 10;
  const unitY = height && height / 8;

  let map = [];

  if (!width || !height) {
    return (
      <View
        style={{
          width: "100%",
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ActivityIndicator />
        <Text
          style={{
            marginTop: 10,
            fontFamily: "Poppins",
            fontSize: 10,
            color: "#e1e1e1",
          }}
        >
          Loading Field Map ...
        </Text>
      </View>
    );
  }

  return (
    <View
      style={{
        width: width,
        height: height,
      }}
    >
      <Field2D
        lineThickness={props.lineThickness}
        lineColor={"#2699fbaa"}
        width={width}
        height={height}
        unitX={unitX}
        unitY={unitY}
      />

      <View
        style={{
          width: "100%",
          height: "100%",
          position: "absolute",
          zIndex: 4,
        }}
      >
        {[0, 1, 2, 3, 4, 5, 6, 7].reverse().map((y, index1) => (
          <View
            key={index1}
            style={{ flexDirection: "row", width: "100%", height: unitY }}
          >
            {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((x, index11) => {
              let xpos = x + 1 === 10 ? y + 1 : y;
              let ypos = x + 1 === 10 ? 0 : x + 1;
              return (
                <View
                  key={index11}
                  style={{
                    width: "10%",
                    height: "100%",

                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 10,
                  }}
                >
                  <UnitBox
                    newCordSystem={newCordSystem}
                    x={xpos}
                    y={ypos}
                    onPress={(xy) => props.onPress(xpos + "" + ypos, xy)}
                  />
                </View>
              );
            })}
          </View>
        ))}
      </View>
    </View>
  );
};

const UnitBox = (props) => {
  const newCordSystem = props.newCordSystem;
  const [isVisibleZoomedMap, setIsVisibleZoomedMap] = useState(false);

  const position = Number(props.x + "" + props.y);
  const { rows, columns } = blockType(position);

  const closeZoomedMap = () => {
    setIsVisibleZoomedMap(false);
  };
  return (
    <TouchableOpacity
      onPress={() => {
        props.newCordSystem ?? props.onPress();
        setIsVisibleZoomedMap(true);
      }}
      style={[
        styles.unitBoxContainer,
        { outline: "none" },
        props.y !== 0 &&
          props.x % 2 === 0 &&
          (props.x + "" + props.y) % 2 === 0 && {
            backgroundColor: "#2699fb30",
          },
        ,
        props.x % 2 !== 0 &&
          (props.x + "" + props.y) % 2 !== 0 && {
            backgroundColor: "#2699fb30",
          },
        props.x % 2 !== 0 && props.y === 0 && { backgroundColor: "#2699fb30" },
      ]}
    >
      <Text style={{ fontSize: 12, fontWeight: "700", color: "#2699fb" }}>
        {props.x + "" + props.y}
      </Text>

      {newCordSystem && isVisibleZoomedMap ? (
        <ZoomedField
          isVisible={isVisibleZoomedMap}
          onClose={closeZoomedMap}
          props={props}
          rows={rows}
          columns={columns}
          onPress={({ x, y }) => {
            props.onPress({ x, y });
          }}
        />
      ) : null}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: "100%",
    justifyContent: "center",
    alignItems: "flex-start",
  },
  unitBoxContainer: {
    flex: 1,
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
});

export default TwoDFieldMap;
